/**
 * Cams API
 * Cams
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface UserLoginInfoDto { 
    id?: number;
    name?: string | null;
    middleName?: string | null;
    surname?: string | null;
    userName?: string | null;
    emailAddress?: string | null;
    countryCode?: string | null;
    phoneNumber?: string | null;
    roles?: Array<string> | null;
    defaultBranchId?: number | null;
    hasWBAAccess?: boolean;
}

